import { Tabs, Ticket } from '@core/Areas/AccountActivity/types'

export const canAllowShareForFuturesTicket = (activeTab: Tabs, ticket: Ticket) => {
  return !(
    activeTab === 'pending' &&
    ticket.legs[0].eventType === 'Feature Races' &&
    !ticket.legs.some(leg => leg.status === 'A')
  )
}
